import '../../css/pages/course_preview.less'
import '../../css/pages/course_preview_style_1.less'
import '../../css/pages/course_preview_style_1_6.less'
import '../../css/pages/course_preview_style_1_9.less'
import '../../css/pages/course_preview_style_2.less'
import '../../css/pages/course_preview_style_2_6.less'
import '../../css/pages/course_preview_style_3.less'
import '../../css/pages/course_preview_style_3_6.less'
import '../../css/pages/course_preview_style_4.less'
import '../../css/pages/course_preview_style_4_6.less'
import { npuEventStatistics } from './utils/npuTracker'
var offlineList = offlineArr.map(item => ({
    ...item,
    value: courseInfo.entityData[item.key] || ""
})).filter(item => item.value)

new Vue({
    el: '#app',
    data: function () {
        this.xCasTokenStr = ((!this.getIfPc() && bannerPlateType == 6) ? ('&x-cas-token=' + (localStorage.getItem('x-cas-token-app') || '')) : '')
        return {
            prefix,
            courseInfo,
            bannerPlateType,
            courseType,
            courseId: contentId,
            activeTab: (courseInfo.entityData.menu_list && courseInfo.entityData.menu_list.length) ? courseInfo.entityData.menu_list[0].value : "course_overview",
            chapterList: [],//章节列表
            // config: {
            //     showComment: false,//是否显示课程评论
            // },
            evaluationTatal: {
                courseId: '',
                average: 0,
                star1: 0,
                star2: 0,
                star3: 0,
                star4: 0,
                star5: 0,
                total: 0,
            },
            isEnd: false,
            isStart: false,
            canPreview: false,
            isJoin,
            publishStatus: courseInfo.entityData.publishStatus,
            contentInfo: {
                subject: courseInfo.entityData.subjectName,
                college: courseInfo.entityData.collegeName,
                major: courseInfo.entityData.majorName,
                platform_name: courseInfo.entityData.platform_name || '',
            },
            teacherList: [],
            realTeacherList: [],//真实教学团队
            teacherSwiperList: [],//教师轮播列表
            headPictureHeight: 0,
            offlineList, //线下课程信息
            headActive: bannerPlateType == '2' ? true : false,
            scrollNavStatus: true,//开启页面滚动监听控制导航样式
            aboutCourse: [],//相关课程
            courseJoinNumber: 0,
            activeMenu: '',//当前选中菜单
            previewStyle3Active: 'info',//样式4当前选中菜单
            coverVideo: {},//视频封面
            menuListFormat: [],//菜单数据
            menuListFormat1: [], //模版1
            joinModalVisible: false,//班级课加入课程弹框
            joinSpocModalVisible: false,//公开课加入课程管理员可选弹框
            inviteCode: '',//邀请码
            chooseRole: 0,
            joinLoading: false,//加入loading
            semesterList: [],//学期列表
            releasedType,
            isCau: false, // 是否为长安大学环境
            hasChapter: false, // 当前课程是否有章节内容，第三方课程如果没有的话，不会展示当前平台学习按钮
            isSpoc: false, // 当前课程是不是来自于翱翔，来自于翱翔的需要按照原逻辑加入学习
            permissionReady: false, //权限是否准备完成，未ready不显示页面，防止第三方直接跳转会闪现preview页面
        }
    },
    computed: {
        showComment: function () {//是否显示课程评论
            if (bannerPlateType == 15) {   // mooc
                return false
            }
            if (courseType === 1) {   // mooc
                return this.sysModulesFormat.includes('mooc_comment_display')
            }
            if (courseType === 2) {   // spoc
                return this.sysModulesFormat.includes('spoc_comment_display')
            }
            if (courseType === 3) {   // spoc
                return this.sysModulesFormat.includes('training_comment_display')
            }
            return false
        },
        joinBtnDisable: function () {
            const currentDate = (new Date()).getTime()
            let { start_time, end_time } = courseInfo.entityData
            let isEnd = end_time && (end_time <= currentDate)
            //spoc开课7天前可进入详情页
            if (courseType === 2 || courseType === 3) {
                // return false
                start_time = new Date(start_time).getTime() - 7 * 24 * 60 * 60 * 1000
            }
            let isStart = start_time ? ((new Date(start_time)).getTime() <= currentDate) : true
            //允许结课后加入
            let allowContinueStydy = courseInfo.entityData.course_finish_continue_learning
            // return !isStart || isEnd
            if (!isStart) {
                if (courseType === 2 || courseType === 3) {
                    return '课程开始前7天可进入'
                } else {
                    return '课程未开始'
                }
            } else if (isEnd) {
                if (allowContinueStydy) {
                    return false
                } else {
                    return '课程已结束'
                }
            } else {
                return false
            }
        },
        ifCourseTeacher() {
            const { user_code } = this.loginUserInfo || {}
            return courseInfo.entityData.teacher && courseInfo.entityData.teacher.includes(user_code)
        },
        ifMaxNumber() {
            //是否已最大参与人数
            return courseInfo.entityData.isNumberStudents == 0 && this.courseJoinNumber >= courseInfo.entityData.numberStudents
        }
    },
    mounted() {
        if (courseInfo.entityData.courseType == 4) {
            location.replace('/learn/workbench/#/mapv4?sm=' + courseInfo.entityData.course_semester_id + '&type=map&id=' + this.courseId)
            return
        }
        //监听智能助手加载完成
        window.addEventListener('onLoadChatGpt', function () {
            window.setChatGptUrl({ course_id: courseInfo.contentId })
        })
        const currentDate = (new Date()).valueOf()
        let { start_time, end_time } = courseInfo.entityData
        this.isEnd = end_time && (end_time <= currentDate)
        this.isStart = start_time ? ((new Date(start_time)).valueOf() <= currentDate) : true
        this.checkIsSpoc()
        //获取章节树
        this.initChapterList()
        //获取教学团队信息
        // this.getTeacherTeam()
        // setTimeout(_ => {
        //     const status = [[${courseInfo.entityData.publishStatus}]]
        //     const {user_code, roles} = this.loginUserInfo
        //     if (status == 0) {
        //         if (user_code == 'sys' || user_code == 'zhiliao' || roles?.includes("r_course_manager") || roles?.includes('r_resource_manager')) {
        //             this.canPreview = true
        //         }
        //     }
        //     if (teacherInfo instanceof Array) {
        //         const filterArr = teacherInfo.filter(item => item.user_code === this.loginUserInfo.user_code)
        //         this.canPreview = filterArr.length > 0
        //     }
        // }, 100)
        // this.getModuleList()
        this.getTotalEvaluation()
        //防止初始化失败，延时再判断一次
        let that = this
        this.getAboutCourse()
        this.getJoinNumber()
        this.initCoverVideo()
        this.initMenuList()
        this.$on('ready', () => {
            //获取用户信息后执行
            this.initPermission()
        })
        //获取课程期次信息
        // return
        API.reqCourseSemester({ courseId: courseInfo.contentId }).then(res => {
            if (res.status == 200) {
                this.semesterList = res.data
            }
        })
        API.reqCourseJoinNumber({ courseId: courseInfo.contentId, courseType: courseInfo.entityData.courseType })
    },
    methods: {
        //判断权限
        async initPermission() {
            const res = await API.reqUserInfo({timestamp: new Date().getTime()})
            let isCau_ = false
            let thirdPlfShow = false
            try {
                res.data.libraryDate.forEach((item) => {
                    if (item.code === "target_customer" && item.value === "cau") {
                        this.isCau = true
                        isCau_ = true
                    }
                })
                res.data.moduleCode.extendMessage.forEach(item => {
                    if (item.code == "third_paltform_preview_show" && item.value == 'false') {
                        thirdPlfShow = true
                    }
                })

            } catch (error) {

            }
            if (this.sysModulesFormat && thirdPlfShow && courseInfo.entityData.jump_address && !isCau_) {
                //第三方平台开关控制是否直接跳转第三方页面
                // 长安大学拥有当前平台学习的功能，不跳转
                let href = this.getThirdPartLink()
                location.href = href
            }else{
                this.permissionReady = true
            }
            //获取教学团队信息
            await this.getTeacherTeam()
            const status = this.publishStatus
            const { user_code, roles = [] } = this.loginUserInfo || {}
            console.log('loginUserInfo', user_code, roles)
            if (status == 0) {
                if (user_code == 'sys' || user_code == 'zhiliao' || roles?.includes("r_course_manager") || roles?.includes('r_resource_manager')) {
                    this.canPreview = true
                }
            }
            if (this.loginUserInfo) {
                const filterArr = this.teacherList.filter(item => item.user_code === this.loginUserInfo.user_code)
                this.canPreview = filterArr.length > 0
            }
            //数据采集
            this.courseUserGather()
        },
        courseTabChange(e) {
            // window.scrollTo({
            //     top: jQuery(`#${e.name}`)[0].offsetTop + jQuery('#main>.container')[0].offsetTop - jQuery('#head_container')[0].clientHeight,
            //     behavior: 'smooth',
            // });
            jQuery(`#${e.name}`)[0].scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            })
        },
        async initChapterList() {
            // if(courseInfo.entityData.platform_name != platformName) return
            let treeData = []
            await API.reqChapterTree({ courseId: this.courseId, type: releasedType, semester: courseInfo.entityData.course_semester_id }).then(res => {
                console.log('课程章节数据：', res)
                if (res.status == 200) {
                    treeData = res.data
                    this.hasChapter = res.data.length > 0
                }
            })
            if (treeData && treeData.length) {
                let newTreeData = this.filterPublishChaper(treeData)
                let arr = newTreeData.filter((item) => {
                    // return item && item.info && item.info.publish_status === 1
                    return item && item.info
                }).map(el => {
                    let coursewareNum = this.countResourceType(el.childInfo, 'courseware')
                    let referenceNum = this.countResourceType(el.childInfo, 'reference')
                    let homeworkNum = this.countResourceType(el.childInfo, 'homework')
                    let hyperlinkNum = this.countResourceType(el.childInfo, 'hyperlink')
                    return {
                        ...el,
                        coursewareNum,
                        referenceNum,
                        homeworkNum,
                        hyperlinkNum,
                        hasNumber: coursewareNum || referenceNum || homeworkNum || hyperlinkNum
                    }
                })
                console.log('treeDataformat', arr)
                //小节序号处理
                arr = arr.map(chapter => {
                    let sortNum = 1
                    chapter.childInfo = chapter.childInfo.map(section => {
                        if (!section.info.resourse_type) {
                            section.sort = sortNum
                            sortNum++
                        }
                        return section
                    })
                    return chapter
                })
                this.chapterList = arr
                console.log('chapterList', this.chapterList)
            }
        },
        //过滤掉隐藏章节
        filterPublishChaper(arr) {
            let newArr = arr.filter(el => el.info.publish_status == 1)
            return newArr.map(el => {
                let obj = { ...el }
                if (el.childInfo && el.childInfo.length) {
                    obj.childInfo = this.filterPublishChaper(el.childInfo)
                }
                return obj
            })
        },
        countResourceType(arr, type) {
            let num = 0
            arr.map(el => {
                if (el.childInfo && el.childInfo.length) {
                    num += this.countResourceType(el.childInfo, type)
                } else if (type && el.info.resource_attributes && el.info.resource_attributes == type) {
                    num++
                } else {
                    return 0
                }
            })
            // console.log(arr,num)
            return num
        },
        // getModuleList() {
        //     API.reqModuleParameterList(['spoc_kcgl']).then(res => {
        //         if (res.errorCode == 'success' && res.extendMessage) {
        //             res.extendMessage.forEach(el => {
        //                 if (el.code == 'spoc_comment_display' && el.value == 'true') this.$set(this.config, 'showComment', true)
        //             })
        //         }
        //     })
        // },
        getTotalEvaluation() {
            API.reqTotalEvaluation(contentId).then(res => {
                if (res && res.message == config.successMessage) {
                    let temp = {}
                    if (res.data) {
                        Object.keys(res.data).forEach(item => {
                            temp[item] = res.data[item] || 0
                        })
                        this.evaluationTatal = temp
                    }
                }
            })
        },
        handleJoinSpoc() {
            const that = this
            if (!window.hasLogin) return location.href = this.loginHref
            let ifCourseTeacher = that.ifManager || that.realTeacherList.map(teacher => teacher.userCode).includes((that.loginUserInfo || {}).user_code)
            if (that.publishStatus == 0 && !ifCourseTeacher && !that.ifManager) {
                //未发布
                that.$message.warning('课程已下架')
                return
            }
            this.joinModalVisible = true
        },
        handleReleased() {
            let href = prefix + 'course/detail/' + (courseType == 1 ? 'mooc/' : courseType == 2 ? 'spoc/' : 'training/') +
                'courseWare/' + contentId + '?type=' + releasedType + '&semester=' + courseInfo.entityData.course_semester_id + this.xCasTokenStr
            location.href = href
        },
        jumpToOriginPlatform() {
            let href = ''
            if (courseInfo.entityData.type && courseInfo.entityData.type == "biz_sobey_dock_course") {
                href = prefix + 'course/detail/' + 'dockCourse/courseWare/' + contentId +
                    '?type=' + (courseType == 1 ? 'biz_sobey_dock_course' : releasedType) + '&semester=' +
                    courseInfo.entityData.course_semester_id + this.xCasTokenStr
            } else {
                href = prefix + 'course/detail/' + (courseType == 1 ? 'mooc/' : courseType == 2 ? 'spoc/' : 'training/') +
                    'courseWare/' + contentId + '?type=' + (courseType == 1 ? 'biz_sobey_dock_course' : releasedType) + '&semester=' +
                    courseInfo.entityData.course_semester_id + this.xCasTokenStr
            }
            location.href = href
        },
        //spoc课程点击立即加入
        joinSpocSubmit(ifManager) {
            let courseType = courseInfo.entityData.courseType
            let href = prefix + 'course/detail/' + (courseType == 1 ? 'mooc/' : courseType == 2 ? 'spoc/' : 'training/') + 'courseWare/' + contentId + '?type=' + releasedType + '&semester=' + courseInfo.entityData.course_semester_id + this.xCasTokenStr
            //管理员进入入直接跳转
            if (ifManager) return location.href = href
            if (!this.inviteCode) return this.$message.warning('请输入邀请码！')
            let param = { courseId: courseInfo.contentId, code: this.inviteCode, courseSemester: courseInfo.entityData.course_semester_id, courseType }
            if (this.ifManager && !ifManager) param.chooseRole = 1
            API.reqJoinSpoc(param).then(res => {
                if (res.status == 200) {
                    //加入成功
                    this.joinModalVisible = false
                    this.$set(this.courseInfo, 'isJoin', true)
                    this.$message.success('加入成功！')
                    location.href = href
                } else {
                    this.$message.error(res.message || '加入失败！')
                }
                //西工大统计-加入课程
                npuEventStatistics({
                    eventCode: 'subscribe_course',
                    eventOpeartionObjectCatelogName: '班级课',
                    eventOpeartionObjectCatelogCode: 'spoc',
                    eventOpeartionObjectName: courseInfo.name,
                    eventOpeartionObjectCode: courseInfo.contentId,
                    eventOpeartionObjectDetail: '加入课程' + courseInfo.name,
                    eventOpeartionResult: res.status == 200 ? '成功' : '失败',
                })
            })
        },
        // 公开课、班级课普通方式加入
        joinHandle(e) {
            let that = this
            let courseType = courseInfo.entityData.courseType
            let href = prefix + 'course/detail/' + (courseType == 1 ? 'mooc/' : courseType == 2 ? 'spoc/' : 'training/') + 'courseWare/' + contentId + '?type=' + releasedType + '&semester=' + courseInfo.entityData.course_semester_id + this.xCasTokenStr
            let ifCourseTeacher = that.ifManager || that.realTeacherList.map(teacher => teacher.userCode).includes((that.loginUserInfo || {}).user_code)
            if (that.publishStatus == 0 && !ifCourseTeacher && !that.ifManager) {
                //未发布
                that.$message.warning('课程已下架')
                return
            }
            if (unLoginShow && !window.hasLogin) {
                //对外公开
                location.href = href
                return
            } else {
                if (!window.hasLogin) {
                    this.$message.info('请登录')
                    location.href = this.loginHref
                    return
                } else {
                    //管理员，弹出加入角色选择弹框
                    if (ifCourseTeacher && !courseInfo.isJoin && !that.joinSpocModalVisible && courseType == 1) {
                        return that.joinSpocModalVisible = true
                    }
                    let flag = false
                    //course_finish_continue_learning 结课后是否可进入学习 ，true直接跳转详情页
                    if ((courseInfo.enableJoin && that.chooseRole != 1) || courseInfo.isJoin) {
                        location.href = href
                    }
                    if (courseInfo.entityData.courseType == 1) {
                        //mooc enableJoin false并且未加入需调接口
                        if (!courseInfo.enableJoin && !courseInfo.isJoin) {
                            flag = true
                        }
                    } else {
                        //spoc enableJoin true 并且 未加入 并且 非相应角色，enableJoin字段与mooc相反
                        if (courseInfo.enableJoin && !courseInfo.isJoin && this.shouldIJoin()) {
                            flag = true
                        }
                    }
                    //管理员、学生角色需调加入接口
                    if (ifCourseTeacher && that.chooseRole == 1) {
                        flag = true
                    }
                    if (flag) {
                        // mooc未加入需调接口
                        let param = {
                            courseId: contentId,
                            courseType: courseType,
                            courseSemester: courseInfo.entityData.course_semester_id
                        }
                        if (ifCourseTeacher) param.chooseRole = that.chooseRole
                        that.joinLoading = true
                        API.reqCourseJion(param).then(res => {
                            if (res.status === 200) {
                                this.$message.success('加入课程成功');
                                let href = prefix + 'course/detail/' + contentId + '?type=' + releasedType + '&semester=' + courseInfo.entityData.course_semester_id + this.xCasTokenStr
                                location.href = href
                            } else {
                                this.$message.error(res.message || '发生了错误');
                            }
                            //西工大统计-加入课程
                            npuEventStatistics({
                                eventCode: 'subscribe_course',
                                eventOpeartionObjectCatelogName: '公开课',
                                eventOpeartionObjectCatelogCode: 'mooc',
                                eventOpeartionObjectName: courseInfo.name,
                                eventOpeartionObjectCode: courseInfo.contentId,
                                eventOpeartionObjectDetail: '加入课程' + courseInfo.name,
                                eventOpeartionResult: res.status == 200 ? '成功' : '失败',
                            })
                        }).catch(err => {
                            // console.error('发生了错误',err)
                            // this.$message.error('发生了错误');
                        }).finally(() => {
                            that.joinLoading = false
                        })
                    } else {
                        location.href = href
                    }
                }

            }
        },
        //判断该用户进入spoc时是否需要调加入接口
        shouldIJoin() {
            // console.log(this.loginUserInfo)
            if (this.loginUserInfo && this.loginUserInfo.roles) {
                const excludeRoles = ['r_sys_manager', 'zhiliao', 'r_course_manager', 'admin_S1', 'r_second_manager']
                const excludeCodes = ['sys', 'zhiliao']
                let state = true //true为需要调接口
                //sys、课程管理员、admin、zhiliao不需调加入接口
                excludeRoles.map(role => {
                    if (this.loginUserInfo.roles.includes(role)) {
                        state = false
                    }
                })
                if (excludeCodes.includes(this.loginUserInfo.user_code)) {
                    state = false
                }
                // console.log(teacherInfo)
                const teacherCodes = this.teacherList.map(teacher => teacher.userCode)
                if (teacherCodes.includes(this.loginUserInfo.user_code)) {
                    state = false
                }
                return state
            } else {
                return false
            }
        },
        toChinesNum(num) {
            let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; //changeNum[0] = "零"
            let unit = ["", "十", "百", "千", "万"];
            num = parseInt(num);
            let getWan = (temp) => {
                let strArr = temp.toString().split("").reverse();
                let newNum = "";
                for (var i = 0; i < strArr.length; i++) {
                    newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
                }
                return newNum;
            }
            let overWan = Math.floor(num / 10000);
            let noWan = num % 10000;
            if (noWan.toString().length < 4) noWan = "0" + noWan;
            let str = overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
            //过滤10-19的数
            str = str.replace(/^一十/, '十')
            return str
        },
        teacherSwiperInit() {
            this.bannerSwiper = new Swiper('.teacher_swiper', {
                loop: true, // 循环模式选项
                autoplay: false,
                // 如果需要分页器
                pagination: {
                    el: '.swiper_pagination',
                },
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: `.swiper-button-next`,
                    prevEl: `.swiper-button-prev`,
                },
            })
        },
        //获取相关课程
        getAboutCourse() {
            const that = this
            API.reqRecommendAboutCourse({ courseId: this.courseId }).then(res => {
                // console.log(res)
                if (res.status == 200) {
                    that.aboutCourse = res.data || []
                }
            })
        },
        //获取教学团队信息
        getTeacherTeam() {
            const that = this
            return new Promise(async (res, rej) => {
                let teacherList = []
                let customTeacherTeam = this.courseInfo.entityData.menu_list ? this.courseInfo.entityData.menu_list.find(el => el.value == 'teacherTeam') : null
                console.log('customTeacherTeam', customTeacherTeam)
                //自定义教学团队
                if (customTeacherTeam && customTeacherTeam.content) {
                    teacherList = customTeacherTeam.content
                    //也要获取授课教师列表用于判断角色
                    API.reqTeacherTeam({ courseId: this.courseId }).then(res => {
                        // console.log(res)
                        if (res.status == 200) {
                            that.realTeacherList = (res.data || []).filter(el => el.type != '助教')
                        }
                    })
                } else {
                    await API.reqTeacherTeam({ courseId: this.courseId }).then(res => {
                        // console.log(res)
                        if (res.status == 200) {
                            teacherList = (res.data || []).filter(el => el.type != '助教')
                            that.realTeacherList = teacherList
                        }
                    })
                }
                this.teacherList = teacherList
                this.$nextTick(() => {
                    let slides = 5
                    if (this.bannerPlateType == 6) {
                        slides = 1
                    }
                    if (document.querySelector('.teacher_swiper')) {
                        slides = parseInt(document.querySelector('.teacher_swiper').getAttribute('slides') || 5)
                    }
                    let teacherSwiperList = []
                    for (var i = 0; i < teacherList.length; i += slides) {
                        teacherSwiperList.push(teacherList.slice(i, i + slides));
                    }
                    console.log('teacherSwiperList', teacherSwiperList)
                    // this.teacherList = (res.data || []).filter(el => el.type != '助教')
                    this.teacherList = teacherList
                    this.teacherSwiperList = teacherSwiperList
                    this.$nextTick(() => this.teacherSwiperInit())
                })
                res()

            })
        },
        //获取参与人数
        getJoinNumber() {
            API.reqJoinNumber({ courseId: courseInfo.contentId, courseSemester: courseInfo.entityData.course_semester_id }).then(res => {
                if (res.status == 200) {
                    this.courseJoinNumber = res.data
                }
            })
        },
        //获取视频封面
        async initCoverVideo() {
            const that = this
            let data = JSON.parse(courseInfo.entityData.cover_video || "{}")
            if (!data || !data.resourceId) return
            if (data.src) {
                this.coverVideo.src = data.src
                console.log('this.coverVideo', this.coverVideo)
                // this.coverVideo.keyframe = data.keyframe
            } else {
                await API.reqFileInfo([data.resourceId]).then(res => {
                    if (res.status == 200 && res.data.length) {
                        this.coverVideo.src = res.data[0].filePath
                    }
                })
            }
            let url = this.coverVideo.src
            this.$nextTick(() => {
                setTimeout(() => {
                    //初始化播放器
                    let option = {
                        id: 'player',
                        url,
                        fluid: true,//流式布局
                        miniplayerConfig: {
                            bottom: 20,
                            right: 0,
                            width: 320,
                            height: 180
                        },
                        keyframe: that.coverVideo.keyframe,
                        controlslist: "nodownload",
                        videoInit: true,//初始化显示首帧
                    }
                    if (url && url.split('?')[0].includes('.m3u8')) {
                        that.player = new HlsJsPlayer(option);
                    } else {
                        that.player = new Player(option);
                    }
                }, 1000);
            })
        },
        //初始化菜单显示
        initMenuList() {
            let arr = courseInfo.entityData.menu_list || []
            this.menuListFormat = arr.filter(el => {
                if (el.value == 'courseInfo') return false
                if (el.value == 'chapter') return true
                if (el.value == 'teacherTeam') return true
                //除以上菜单外，content为空即不显示
                if (el.content) return true
                return false
            }).map(el => {
                return { ...el, value: String(el.value) }
            })
            this.menuListFormat1 = this.menuListFormat.filter(el => el.value != 'teacherTeam')
            console.log('menuListFormat', this.menuListFormat)
            if (this.menuListFormat && this.menuListFormat.length) {
                this.activeTab = this.menuListFormat[0].value
            }
        },
        //数据采集
        courseUserGather() {
            //只采集登录用户mooc数据
            if (!this.loginUserInfo || !this.loginUserInfo.user_code || courseInfo.entityData.courseType == 2) return
            let params = {
                type: "edu.user_course",
                content: {
                    user_code: this.loginUserInfo.user_code,
                }
            }
            let teacher_codes = this.teacherList.filter(el => (el.type == '课程负责人' || el.type == '主讲老师')).map(el => el.userCode)
            if (teacher_codes.length) {
                params.content.teacher_codes = teacher_codes
            }
            let subject_code = (courseInfo.entityData.subject || []).pop()
            if (subject_code) {
                params.content.subject_code = subject_code
            }
            let college_code = (courseInfo.entityData.college || []).pop()
            if (subject_code) {
                params.content.college_code = college_code
            }
            API.reqCourseUserGather(params).then()
        },
        //期次切换
        handleSemesterChange(val) {
            location.replace(location.pathname + '?semester=' + val)
        },
        getDetailHref(course) {
            return (course.type_ == 'biz_sobey_course' ? '/learn/course/micro/' :
                (course.type_ == 'biz_sobey_teaching_courses' && course.courseType == 1) ? '/learn/course/preview/mooc/' :
                    (course.type_ == 'biz_sobey_teaching_courses' && course.courseType == 2) ? '/learn/course/preview/spoc/' :
                        (course.type_ == 'biz_sobey_teaching_courses' && course.courseType == 3) ? '/learn/course/preview/training/' :
                            '/learn/course/preview/thirdparty/') + course.contentId_
        },
        checkIsSpoc() {
            // 只有非spoc平台才会有type字段
            if (courseInfo.entityData.type) {
                this.isSpoc = false
            } else {
                this.isSpoc = true
            }
        },
        getThirdPartLink(){
            let href = courseInfo.entityData.jump_address || courseInfo.entityData.link
            if(courseInfo.entityData.platform_name == '智慧树' && this.targetCustomer === "npu"){
                href = 'http://oc.zhihuishu.com/oauth/callback/nwpukg?kh=' + btoa(courseInfo.entityData.jump_address)
            }
            return href
        }
    }
})
